'use es6';
/* eslint-disable eqeqeq */

import ImmutableModel from 'DesignData/models/ImmutableModel';
import { NONE, LAYOUT, GLOBAL_GROUP, GLOBAL_WIDGET, TEMPLATE, CUSTOM_WIDGET, SETTINGS, WELCOME, GETTING_STARTED } from 'DesignData/enums/DesignAssetTypes';
import { tryParseNumber } from 'DesignData/lib/text';
import EditorOptions from 'DesignData/models/app/EditorOptions';
/**
 * @typedef {Object} Tab
 * @property {DesignAssetTypes} assetType
 * @property {Number|String}    id
 * @property {EditorOptions}    editorOptions
 * @property {String}           label - Default label. Used when asset data has not loaded yet.
 */

export default class Tab extends ImmutableModel {
  constructor(__props = {}) {
    // Validate for required fields.
    if (!('assetType' in __props)) {
      throw new TypeError('assetType is required');
    }

    if (!('id' in __props)) {
      throw new TypeError('id is required');
    }

    if (__props.editorOptions && !(__props.editorOptions instanceof EditorOptions)) {
      // This will throw if editorOptions values are invalid
      const editorOptions = new EditorOptions(__props.editorOptions);
      __props = Object.assign({}, __props, {
        editorOptions
      });
    } // Spread given props into a new object.


    const props = Object.assign({}, __props); // Try converting `assetId` to an integer.

    const id = tryParseNumber(props.id);

    if (id == props.id) {
      props.id = id;
    } // Provide better default `label` if one is not provided.


    if (!__props.label) {
      // TODO: I18n
      switch (props.assetType) {
        case LAYOUT:
        case GLOBAL_GROUP:
          props.label = 'Template';
          break;

        case TEMPLATE:
          props.label = 'Coded File';
          break;

        case CUSTOM_WIDGET:
          props.label = 'Custom Widget';
          break;

        case GLOBAL_WIDGET:
          props.label = 'Global Widget';
          break;

        case SETTINGS:
          props.label = 'Settings';
          break;

        case WELCOME:
          props.label = 'Welcome';
          break;

        case GETTING_STARTED:
          props.label = 'Getting Started';
          break;

        default:
          break;
      }
    }

    return super(props);
  }

}

Tab.DEFAULT_FIELDS = () => {
  return {
    /**
     * The type
     * @required
     */
    assetType: NONE,

    /**
     * The tab id - must be unique.
     * @required
     */
    id: 0,

    /**
     * Options data
     */
    editorOptions: new EditorOptions(),

    /**
     * Display data.
     */
    label: '',

    /**
     * Time tab was last updated
     */
    lastActiveAt: Date.now(),

    /**
     * Whether tab is pinned
     */
    isPinned: false
  };
};